import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './lib/element'
// import './assets/scss/aui.scss'
// import './assets/scss/common.scss'
import './assets/css/common.less'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(Vant);
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
